module.exports = __webpack_public_path__ + "static/media/power_robot.4ac10a8b.jpg";